var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { Trans } from '@lingui/macro';
import { TableBodyCell, Menu, MenuList, MenuItem, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { FileDownloads } from './FileDownloads';
export function ContextMenuCell(props) {
    const { id, openUrl, editUrl, onDuplicate, onMove, onRename, onDelete, onEditAccess } = props, restProps = __rest(props, ["id", "openUrl", "editUrl", "onDuplicate", "onMove", "onRename", "onDelete", "onEditAccess"]);
    const [open, setOpen] = useState(false);
    const handleClick = (callback) => () => {
        setOpen(false);
        return callback();
    };
    return (<TableBodyCell stickyColumn="right" {...restProps} headers="filesystemtable-contextmenu">
      <Menu open={open} onClose={() => setOpen(false)} target={<IconButton appearance="ghost" size="medium" onClick={() => setOpen(!open)}>
            <Falcon icon="ellipsis-h"/>
          </IconButton>}>
        <MenuList>
          {openUrl && (<MenuItem as={Link} to={openUrl}>
              <Trans>Open</Trans>
            </MenuItem>)}
          {editUrl && (<MenuItem as={Link} to={editUrl}>
              <Trans>Edit</Trans>
            </MenuItem>)}
          {onDuplicate && (<MenuItem onClick={handleClick(onDuplicate)}>
              <Trans>Create copy</Trans>
            </MenuItem>)}
          {onEditAccess && (<MenuItem onClick={handleClick(onEditAccess)}>
              <Trans>Access</Trans>
            </MenuItem>)}
          {onMove && (<MenuItem onClick={handleClick(onMove)}>
              <Trans>Move</Trans>
            </MenuItem>)}
          {onRename && (<MenuItem onClick={handleClick(onRename)}>
              <Trans>Rename</Trans>
            </MenuItem>)}
          <FileDownloads id={id}/>
          {onDelete && (<MenuItem onClick={handleClick(onDelete)}>
              <Trans>Delete</Trans>
            </MenuItem>)}
        </MenuList>
      </Menu>
    </TableBodyCell>);
}
